<div class="card">
    <div class="row">
      <div class="col-lg-12">
        <div class="card border-0 shadow-none">
          <div class="card-body">
            <div class="row mb-0" style="min-height: 470px">
                <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine" style="margin-bottom: 0px">
                    <ag-grid-angular [enableCellTextSelection]=true (gridReady)="onGridReady($event)"
                    [columnDefs]="tableSelectedColumn" [defaultColDef]="defaultColDef" [enableCellTextSelection]=true [paginationPageSize]="pageSize"
                    [pagination]="true" [rowData]="saveData" [rowModelType]="" [rowSelection]="'single'"
                    [suppressPaginationPanel]="true" style="width: 100%; height: auto;">
                    </ag-grid-angular>
                </div>
            </div>
            <div class="row mt-0">
                <div class="col-4 col-xs-4 d-flex">
                    <select (change)="onPageSizeChanges($event)" [(ngModel)]="pageSize"
                    class="form-select d-flex justify-content-end col-4" name="pageSize" style="width: auto">
                    <option *ngFor="let pageNum of pageSizeArr" [ngValue]="pageNum">{{pageNum}}</option>
                    </select>
                    <p class="text-muted p-3"> Total Records: {{ collectionSize }}</p>
                </div>
                <div class="col-8 col-xs-8">
                    <ngb-pagination (pageChange)="onPaginationChange($event)" [(page)]="currentPage" [boundaryLinks]="true"
                    [collectionSize]="collectionSize" [maxSize]="5" [pageSize]="pageSize" [rotate]="false" [directionLinks]="true"
                    [ellipses]="false" size="sm" class="d-flex justify-content-end align-right">
                    </ngb-pagination>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>   
</div>